<template>
  <div class="mb-24">
    <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
      <div class="bg-theme-green px-4 py-2 text-white">
        <div class="flex justify-between items-center">
          <div class="font-bold tracking-wider truncate text-single-line break-all leading-tight text-2xl mt-0">
            Add New POS
          </div>
          <div class="flex  items-center">
            
            <!-- <mdicon @click.prevent="clearComponent" size="32" class="close-icon flex justify-end cursor-pointer hover:opacity-60 mb-2 " name="close" /> -->
            <button @click.prevent="addNew()" class="h-10 hover:bg-theme-darkgreen border-0 hover:text-white rounded-md cursor-pointer text-green-400 bg-white py-2 px-4 uppercase ">
              SAVE
            </button>
            <span @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 pl-2 hover:opacity-70">CLOSE</span>
          </div>
        </div>
      </div>

      <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg">

        <div class="mb-3">
          <div class="w-full">

            <div class="flex xl:flex-row flex-col gap-3 items-start ">
              
              <div class="w-full">
                <div :class="'input-wrapper ' + (form.name.error_type)">
                  <label class="text-xs mb-1">Name:</label>
                  <input placeholder="E.g. Samsung A7 Location #1" @keyup="validateFields(['name'])" v-model="form.name.value" class="block rounded bg-gray-black w-full" type="text" />
                  <p class="field-error label-text mt-1" v-if="form.name.error_message" v-text="form.name.error_message"></p>
                </div>
              </div>

              <!-- <div class="w-full xl:w-1/2">
                <div :class="'input-wrapper ' + (form.barcode_scanner_serial.error_type)">
                  <label class="text-xs mb-1">Barcode Scanner Serial:</label>
                  <input placeholder="Something Creative!"  @keyup="validateFields(['barcode_scanner_serial'])" v-model="form.barcode_scanner_serial.value" class="block rounded bg-gray-black w-full" type="text" />
                  <p class="field-error label-text mt-1" v-if="form.barcode_scanner_serial.error_message" v-text="form.barcode_scanner_serial.error_message"></p>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="flex flex-row">
          <div class="w-full xl:w-1/4">
            <label class="text-xs mb-1 mt-0">Status:</label>
              <label class="flex items-center cursor-pointer xl:mt-2">
              <input type="checkbox" v-model="form.status" class="hidden peer">
              <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.status ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
              <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.status ? 'text-theme-green' : 'text-[#F53333]'">{{form.status ? 'On' : 'Off'}}</span>
            </label>
          </div>
          <div class="w-full xl:w-1/4">
            <label class="text-xs mb-1 mt-0">Accept Online Orders:</label>
              <label class="flex items-center cursor-pointer xl:mt-2">
              <input type="checkbox" v-model="form.acceptOnlineOrders" class="hidden peer">
              <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.acceptOnlineOrders ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
              <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.acceptOnlineOrders ? 'text-theme-green' : 'text-[#F53333]'">{{form.acceptOnlineOrders ? 'On' : 'Off'}}</span>
            </label>
          </div>
        </div>
   
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import LocationPosStationApis from "@/controllers/LocationPosStationApis";
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';

export default defineComponent({
  name: "LocationPosAdd",
  components: {
   
  },
  setup() {
    const snackbar = useSnackbar();
    const form = ref({
      name: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      // barcode_scanner_serial: {
      //   value: '',
      //   error_type: '',
      //   error_message: '',
      //   validations: ['required'],
      // },
      status: false,
      acceptOnlineOrders: false
    });
    return {
      form,
      snackbar,
    };
  },
  props:{
    clearComponent: {
      type: Function,
      required: true,
    },
  },

  watch:{
     // Fields cannot have white spaces
    // 'form.barcode_scanner_serial.value'(val){
    //   this.form.barcode_scanner_serial.value = val.replaceAll(/\s/g,'').trim();
    // },
  },

  computed: {
    ...mapGetters({
     
    }),
  },
 
  methods: {
    
     /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },


    /**
     * Add new location Tax
     */
    async addNew() {
      let validate = await this.validateFields(['name']);
      if(!validate) {
        return ;
      }
      this.va_spinner(true);
      let res = await LocationPosStationApis.addLocationPosStation({
          name: this.form.name.value,
          status: this.form.status,
          acceptOnlineOrders: this.form.acceptOnlineOrders
      });
      this.va_spinner(false);
        this.snackbar.add({
        type: 'info',
        text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
      if(res.status == 201 ) {
        this.clearComponent();
        this.emitter.emit("refresh-location-pos-station-list", true);
      }
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>